import { store } from '@/store';
import api from '@api/Api';

export default {

    getCompany(id) {
        return api().get(`/companies/${id}`).then((response) => {
            store.commit('setCompany', response.data.data);
            return response;
        });
    },

    updateCompany(id, params) {
        return api().put(`/companies/${id}`, params).then((response) => {
            store.commit('setCompany', response.data.data);
            return response;
        });
    },

    deleteCompany(id) {
        return api().delete(`/companies/${id}`);
    },

    getProjects(id, params) {
        return api().get(`/companies/${id}/projects`, { params: params });
    },

    createProject(id, params) {
        return api().post(`/companies/${id}/projects`, params).then((response) => {
            store.commit('setProject', response.data.data);
            return response;
        });
    },

    getMembers(id, params) {
        return api().get(`/companies/${id}/members`, { params: params });
    },

    getMemberInvites(id, params) {
        return api().get(`/companies/${id}/member-invites`, { params: params });
    },

    createMemberInvite(id, params) {
        return api().post(`/companies/${id}/member-invites`, params);
    },

    getSubscription(id) {
        return api().get(`/companies/${id}/subscription`);
    },

    createSubscription(id, params) {
        return api().post(`/companies/${id}/subscription`, params).then((response) => {
            store.commit('setCompany', response.data.data);
            return response;
        });
    },

    unlockSubscription(id, params) {
        return api().post(`/companies/${id}/subscription/unlock`, params).then((response) => {
            store.commit('setCompany', response.data.data);
            return response;
        });
    },

    deleteSubscription(id) {
        return api().delete(`/companies/${id}/subscription`).then((response) => {
            store.commit('setCompany', response.data.data);
            return response;
        });
    },

    updatePaymentMethod(id, params) {
        return api().put(`/companies/${id}/payment_method`, params);
    },

    updateBillingAddress(id, params) {
        return api().put(`/companies/${id}/billing_address`, params);
    },

    purchaseProductSms(id, params) {
        return api().post(`/companies/${id}/products/sms`, params);
    },

    purchaseProductLifetime(id, params) {
        return api().post(`/companies/${id}/products/lifetime`, params);
    },

}
